import { gql } from '@apollo/client';

export const getAiProviders = gql`
  query getAiProviders {
    ai {
      url
      token
      providers {
        name
        workflows {
          id
          workflow
          label
        }
      }
    }
  }
`;
